import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { getToken } from 'features/auth/utils/token';

import { adapteCurrencies } from './adapteCurrencies';
import { BaseQuery } from './types';

const baseQuery = fetchBaseQuery({
  baseUrl: '/api/v1/',
  prepareHeaders: (headers) => {
    const token = getToken();
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
}) as BaseQuery;

export const baseApi = createApi({
  reducerPath: 'baseApi',
  baseQuery,
  tagTypes: [
    'Auth',
    'User',
    'UsersList',
    'CourtsList',
    'Settings',
    'Notifications',
    'CoachesList',
    'ProductsList',
    'SMSServices',
    'EmailSettings',
    'WorkTime',
    'CourtsBooking',
    'CoachesBooking',
    'Transactions',
    'GroupsList',
    'WaitingList',
    'imageList'
  ],
  endpoints: (build) => ({
    getCurrencies: build.query<string[], void>({
      query: () => '/currencies',
      transformResponse: adapteCurrencies
    }),
  }),
});

export const {
  useGetCurrenciesQuery,
} = baseApi;
